export const SUBMISSION_TOASTS = {
  MARKED_UNSEEN: 'Submission successfully marked as new',
  TOGGLED_IMPORTANT: 'Marked as {importance}',
  ASSETS_ERROR_OCCURRED: 'Problem #{action} assets',
  SUBMISSION_PUBLISHED: 'Submission successfully submitted',
  SUBMISSION_UPDATED: 'Successfully saved submission changes',
  SUBMISSION_ASSET_DUPLICATE: 'This asset has already been added to a module',
  SUBMISSION_CREATOR_PAID_OUT: 'Payment queued for approval',
};
